import { render, staticRenderFns } from "./handlerDialTermianl.vue?vue&type=template&id=5b181a66&scoped=true&"
import script from "./handlerDialTermianl.vue?vue&type=script&lang=js&"
export * from "./handlerDialTermianl.vue?vue&type=script&lang=js&"
import style0 from "./handlerDialTermianl.vue?vue&type=style&index=0&id=5b181a66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b181a66",
  null
  
)

export default component.exports